import type { LocationPage } from '@/lib/locations'

import { london } from '@/lib/location-pages/london'
import { manchester } from '@/lib/location-pages/manchester'
import { birmingham } from '@/lib/location-pages/birmingham'
import { leeds } from '@/lib/location-pages/leeds'
import { bristol } from '@/lib/location-pages/bristol'
import { glasgow } from '@/lib/location-pages/glasgow'
import { liverpool } from '@/lib/location-pages/liverpool'
import { sheffield } from '@/lib/location-pages/sheffield'
import { newcastle } from '@/lib/location-pages/newcastle'
import { brighton } from '@/lib/location-pages/brighton'
import { doncaster } from '@/lib/location-pages/doncaster'

/** One file per city page so each can be edited on its own. Order = display order. */
export const locationPages: Record<string, LocationPage> = {
    london,
    manchester,
    birmingham,
    leeds,
    bristol,
    glasgow,
    liverpool,
    sheffield,
    newcastle,
    brighton,
    doncaster
}
